import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { Breadcrumbs, Chip, useTheme } from '@mui/material';
import { toggleTag } from '../../state/modules/app';
import { AppStoreState, FilterTag } from 'types';

const ResourceFilterBreadcrumbs = () => {
  const { selectedTags } = useSelector(({ app }: AppStoreState) => app.resource.selectedFilters);
  const dispatch = useDispatch() as any;

  const handleClick = (tag: FilterTag) => {
    dispatch(toggleTag(tag));
  };

  const theme = useTheme();

  return (
    <Breadcrumbs separator="" aria-label="breadcrumb">
      {selectedTags.map(tag => (
        <Chip
          key={tag.id}
          component="a"
          href="#"
          label={tag.value}
          onDelete={() => handleClick(tag)}
          sx={{
            backgroundColor: '#000000',
            height: theme.spacing(3),
            color: '#FFFFFF',
            fontWeight: theme.typography.fontWeightRegular,
            textDecoration: 'none',
            marginTop: '5px',
            '&:hover, &:focus': {
              backgroundColor: '#000000',
              color: '#FFFFFF',
              textDecoration: 'none'
            },
            '&:active': {
              boxShadow: theme.shadows[1],
              backgroundColor: '#000000',
              textDecoration: 'none'
            }
          }}
          deleteIcon={
            <FontAwesomeIcon
              style={{ marginLeft: '5px', marginRight: '10px', color: '#FFFFFF' }}
              icon={faTimes}
            />
          }
        />
      ))}
    </Breadcrumbs>
  );
};

export default ResourceFilterBreadcrumbs;
